/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Consumable from './consumable';
import ConsumableDetail from './consumable-detail';
import ConsumableUpdate from './consumable-update';
import ConsumableDeleteDialog from './consumable-delete-dialog';

const ConsumableRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Consumable />} />
    <Route path="new" element={<ConsumableUpdate />} />
    <Route path=":id">
      <Route index element={<ConsumableDetail />} />
      <Route path="edit" element={<ConsumableUpdate />} />
      <Route path="delete" element={<ConsumableDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConsumableRoutes;
